import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logodashheader  from '../Assets/logo-dash-header.png';
import PayPalSecuredPaymentImg from '../Assets/paypal-secured-payment.png';
import { documentAllowedRepo, documentAllowed, ApiEndpoint, name, platform, hideRegion, summaryInputLimit } from "../Constant";
import Footer from "../Components/footer";
import  Header  from "../Components/header";
import SideBar from "../Components/sidebar";
import Button from "../Components/button";
import Form from "../Components/form";
import { Input, Textarea, Select, File } from "../Components/input";
import { RedirectNotLogin, RedirectContractor, getSession, UpdateState, getState, handleSubmit, BreedForm, AlertMessage, AlertMessageOut, serializeArray, clearSession, RedirectNotReviewerOrEditor } from "../Components/function";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { DateTime } from "../Components/function";
import * as axios from 'axios';
import { SearchSelect } from "../Components/searchselect";

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

export const FingerPrint = async (type = 'visitor') => {
// Get the visitor identifier when you need it.
const fp = await fpPromise;
const result = await fp.get();

// This is the visitor identifier:
if(type === 'visitor'){
 return result.visitorId;
}
else{
  //return result.visitorId;
}
}


class ChangeField extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      userID : '',
      data: '',
      division: '',
      divisions: {},
      email: '',
      message: '',
      loading: '',
      isLoaded: 0,
    }
    }
    
    componentDidMount(){
      RedirectNotLogin();
      RedirectContractor();
      RedirectNotReviewerOrEditor();
      this.loadDataFromServer();
    }

    componentDidUpdate() {
      RedirectNotLogin();
      RedirectContractor();
      RedirectNotReviewerOrEditor();
    }

    loadDataFromServer = async () => {
        
        UpdateState(this, 'loading', '1');
  
        let DeviceSid = await FingerPrint();
  
        let header = {
            headers : {
                'Accept': 'application/json',
                'Content-Type': "application/x-www-form-urlencoded",
                'Authorization': "Bearer " + getSession('token') + ", Session " + DeviceSid + ", Platform "+ platform,
                'My-Custom-Header': name,
                'User-Agent': name+ " Bot",
               }
         };
  
         let datas = new URLSearchParams({
            command: 'fetch',
            cmd: 'fetchdivisions',
            user_id: getSession('userID'),
        }).toString();
         
           axios.get(ApiEndpoint+"/fetchResult?"+datas, header)
           .then(response => {
           
            UpdateState(this, 'loading', '0');
            UpdateState(this, 'isLoaded', 1);
  
            if(response?.data?.retry == true){
               let retryTimes = getState(this, 'retry_times') >= 0 && getState(this, 'retry_times') != '' ? getState(this, 'retry_times') : ''; 
               if(retryTimes != ''){
               if(getState(this, 'retry_times') < 15){
               setTimeout(function(){
               UpdateState(this, 'retry_times', getState(this, 'retry_times') + 1);
               this.loadDataFromServer();
                }, 4000);
               }
               }
             }
  
      
          if(response?.data?.error == false && response?.data?.error != true){
  
          UpdateState(this, 'data', response?.data?.data != "" ? response?.data?.data : "");
          UpdateState(this, 'email', response?.data?.data?.email != "" ? response?.data?.data?.email : "");
          UpdateState(this, 'division', response?.data?.data?.division != "" ? response?.data?.data?.division : "");
          UpdateState(this, 'divisions', response?.data?.divisions != "" ? response?.data?.divisions : "");
          UpdateState(this, 'isTempAccount', response?.data?.isTempAccount != "" ? response?.data?.isTempAccount : "");
          UpdateState(this, 'message', '');
          UpdateState(this, 'loading', '0');
  
          }
          else if(response?.data?.error != false){
            AlertMessage(this, response?.data?.error, 'error');
  
            if(response?.data?.logout == true && response?.data?.token == false){
              setTimeout(function(){
              clearSession();
              window.location.href = "/login";
              }, 4000);
              }
          }
          else{
            AlertMessage(this, "Something went wrong, try again or try to reload the page!", 'error');
          }
        }).catch(err => {
            AlertMessage(this, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
            this.loadDataFromServer();
        });
      }
 
  render(){
    return (
        <div className="App AppWrap">
    
    <Header self={this}/>
    <SideBar self={this}/>

    <div className="App iBG dash-dash">
    <div className="containers">
   

  
  <div className="card-lt-wrap">
    <div className="card-lt">
      
    <div className="info" style={{margin: '0px'}}>
      Request to change your Field of Specialization.
      </div>
    <div className="card-form-lt">
        <div className="title-lt">Update Field of Specialization</div>
     
     <Form route="submit">

     {AlertMessageOut(this)}

      <SearchSelect 
      wrapperClass="form-group-lt"
      defaultValue={getState(this, 'division')} 
      width="100%" borderRadius="0" 
      ref={this.SelectInput} 
      data={getState(this, 'divisions')} 
      placeholder="Select field of specialization" 
      focusplaceholder="Search field of specialization..." 
      self={this} state="division"
      inputReadOnly={getState(this, 'isTempAccount')}
      />

       <Button 
       wrapperClass="form-group-lt" 
       buttonClass="button-lt" 
       buttonText="SUBMIT"
       buttonAction="updatefield"
       disabled={getState(this, 'isTempAccount')}
       self={this} />

       </Form>
      </div>
          
        </div>
        

        <Footer classX="dash-footer"/>

    </div>
    
    </div>

    </div>

    </div>
    );
}

}

export default ChangeField;